import React from 'react';
import { Row } from '../Containers/Row/Row';
import Label from '../form/Label/Label';
import { FlexContainer } from '../Containers/FlexContainer/FlexContainer';
import SectionContainer from '../Containers/SectionContainer';

const WhatsNext = ({
  sectionTitle = 'What’s next',
  leftTitle,
  leftContent,
  rightTitle,
  rightContent,
}) => {
  return (
    <SectionContainer>
      <Row className="bgWhite">
        <Label type="H4" typeHeader={'h2'} className="margb20">
          {sectionTitle}
        </Label>
        <FlexContainer className="column-gap-60 m-column-gap-20 m-flex-column">
          <FlexContainer alignItemsBaseline>
            <div className="chevronRightCss margr20" />
            <div>
              <span className="bold">{leftTitle}</span>
              <p>{leftContent}</p>
            </div>
          </FlexContainer>
          <FlexContainer alignItemsBaseline>
            <div className="chevronRightCss margr20" />
            <div>
              <span className="bold">{rightTitle}</span>
              <p>{rightContent}</p>
            </div>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export default WhatsNext;
